import React from "react";

const CategoryCard = ({ category, isSelected, onClick, styles, screenSize }) => {
  return (
    <div
      style={styles.categoryCard(isSelected, category.color)}
      onClick={onClick}
    >
      <div style={styles.categoryIcon(category.color)}>
        <category.icon size={screenSize.isMobile ? 20 : 24} />
      </div>
      <div style={styles.categoryName}>{category.name}</div>
      <div style={styles.categoryDescription}>{category.description}</div>
    </div>
  );
};

export default CategoryCard;